export default __webpack_public_path__ + "static/media/product.5a464a55.jpg";